import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:px-4" }
const _hoisted_2 = { class: "mt-0" }

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_PopupPromotionNavbar = _resolveComponent("PopupPromotionNavbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_IftaLabel = _resolveComponent("IftaLabel")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PopupMainNavbar),
    _createVNode(_component_PopupPromotionNavbar),
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-xl text-white text-start font-extrabold my-3" }, "คูปอง", -1 /* HOISTED */)),
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.formSubmit && _ctx.formSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_IftaLabel, null, {
            default: _withCtx(() => [
              _createVNode(_component_InputText, {
                id: "coupon",
                modelValue: _ctx.form.coupon.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.form.coupon.value) = $event)),
                class: "w-full",
                invalid: _ctx.form.coupon.invalid,
                placeholder: "โค้ดคูปอง"
              }, null, 8 /* PROPS */, ["modelValue", "invalid"]),
              _cache[2] || (_cache[2] = _createElementVNode("label", { for: "coupon" }, "โค้ด", -1 /* HOISTED */))
            ]),
            _: 1 /* STABLE */,
            __: [2]
          })
        ]),
        _createVNode(_component_Button, {
          loading: _ctx.form.btn.loading,
          label: "ส่ง",
          type: "submit",
          class: "min-w-20 mt-5 bg-black! border-0!"
        }, null, 8 /* PROPS */, ["loading"])
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}